if (!customElements.get('sb-brand-directory')) {
  customElements.define('sb-brand-directory', class extends HTMLElement {
    connectedCallback() {
      this.search = this.querySelector('[data-brand-search]');
      if (!this.search || this.onSearch) return;
      this.letter = this.letter || 'all';
      this.search.disabled = false;
      this.querySelector('[data-brand-controls]').hidden = false;
      this.onSearch = () => {
        this.letter = 'all';
        this.querySelector('[data-brand-controls]').scrollLeft = 0;
        this.filterBrands();
      };
      this.onLetter = event => {
        const button = event.target.closest('[data-brand-letter]');
        if (!button || !this.contains(button)) return;
        this.letter = button.dataset.brandLetter;
        this.search.value = '';
        this.filterBrands();
      };
      this.search.addEventListener('input', this.onSearch);
      this.addEventListener('click', this.onLetter);
      this.filterBrands();
    }

    disconnectedCallback() {
      if (this.search && this.onSearch) this.search.removeEventListener('input', this.onSearch);
      if (this.onLetter) this.removeEventListener('click', this.onLetter);
      this.onSearch = null;
      this.onLetter = null;
    }

    normalize(value) {
      return value.toLocaleLowerCase('de').normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
    }

    filterBrands() {
      const query = this.normalize(this.search.value);
      const filtered = Boolean(query) || this.letter !== 'all';
      let count = 0;
      this.querySelectorAll('[data-brand-item]').forEach(item => {
        const matches = (this.letter === 'all' || item.dataset.brandInitial === this.letter)
          && this.normalize(item.textContent).includes(query);
        item.hidden = !matches;
        if (matches) count += 1;
      });
      this.querySelectorAll('[data-brand-letter]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.brandLetter === this.letter));
      });
      const featured = this.querySelector('[data-brand-featured]');
      if (featured) featured.hidden = filtered;
      this.querySelector('[data-brand-heading]').textContent = query
        ? this.dataset.searchHeading
        : this.letter === 'all'
          ? this.dataset.allHeading
          : this.dataset.letterHeading.replace('__letter__', this.letter);
      this.querySelector('[data-brand-count]').textContent = filtered
        ? this.dataset.countTemplate.replace('__count__', String(count))
        : this.dataset.allCount;
      this.querySelector('[data-brand-empty]').hidden = count !== 0;
      this.querySelector('[data-brand-status]').textContent = filtered
        ? this.dataset.countTemplate.replace('__count__', String(count))
        : '';
    }
  });
}
